import { FetchCompanyDetailsRequestTypes } from '../actions/CompanyDetailsActions';
const initialState = {};

const companyDetails = (state = initialState, {
  type,
  payload
}) => {
  const data = payload && payload.data;

  switch (type) {
    case FetchCompanyDetailsRequestTypes.RECEIVE:
      {
        return data;
      }

    default:
      return state;
  }
};

export default companyDetails;